export const errorMessage = 'sendGaPush espera una'

const validText = ({ category, action }) => {
	if (!category) return 'category'
	if (!action) return 'action'
	return 'label'
}

const sendGaPush = ({ event = 'pushEventGA', category, action, label }) => {
	if (!category || !action || !label) {
		throw new Error(`${errorMessage} ${validText({ category, action })}`)
	}

	window.ga_debug = { trace: true }
	window.dataLayer = window.dataLayer || []
	window.dataLayer.push({
		event,
		category,
		action,
		label
	})
}

export default sendGaPush
